import React from "react";
import { Helmet } from "react-helmet";

const LuckydrawSEO = ({ title = "โคอะลา มาร์ช", description = "Lucky Draw - ใช้ Point แลกของรางวัลสุดพิเศษ", keywords = "lucky draw, โคอะลา, point, รางวัล", ogImage = "", ogUrl = "" }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="title" content={title} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:url" content={ogUrl} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="โคอะลา มาร์ช" />
    </Helmet>
  );
};

export default LuckydrawSEO;
